export default {
  radio: [(v: any) => v === false || !!v || "Required"],
  email: [
    (v: any) => !!v || "E-mail is required",
    (v: any) => /.+@.+\..+/.test(v) || "E-mail must be valid"
  ],
  password: [
    (p: any) => !!p || "Password is required",
    (p: any) => (p && p.length >= 8) || "Minimum 8 characters" // TODO
  ],
  nameRules: [
    (v: any) => !!v || "Required",
    (v: any) =>
      /^[a-zA-Z -]+$/.test(v) || "Name cannot have symbols except hyphens (-)"
  ],
  dateRules: [
    (v: string) => !!v || "Required",
    (v: string) =>
      /^[1,2][0,9][0-9][0-9]-[0-1][0-9]-[0-3][0-9]$/.test(v) ||
      "Enter a valid date in format YYYY-MM-DD",
    (v: string) => new Date(v) < new Date() || "Date cannot be in the future"
  ],
  textRules: [
    (v: any) => !!v || "Required",
    (v: any) =>
      /^[a-zA-Z -]+$/.test(v) || "Field cannot have symbols except hyphens (-)"
  ],
  textRulesNotRequired: [
    (v: any) =>
      v.length == 0 ||
      /^[a-zA-Z -]+$/.test(v) ||
      "Field cannot have symbols except hyphens (-)"
  ],
  integerRules: [
    (value: any) => !!value || "Required",
    (value: any) => value >= 0 || "Enter a valid positive number"
  ],
  listRules: [
    (value: any) =>
      /^[a-zA-Z0-9 -,]+$/.test(value) ||
      "Field cannot have any symbols except hyphens (-) or commas (,)"
  ],
  required: [(v: any) => !!v || "Required"]
};
